export default "__VITE_ASSET__MoX1rvDa__"